import * as React from 'react';

interface IDoomsdayStartProps {
  start:  () => void;
}

export default class DoomsdayStart extends React.PureComponent<IDoomsdayStartProps> {

  constructor(props: IDoomsdayStartProps) {
    super(props);
    this.start = this.start.bind(this);
  }

  public render() {
    return (
      <div className="row">
        <div className="col" />
        <div className="col text-center">
          <button
            type="button"
            className="btn btn-success btn-lg m-2"
            onClick={this.start}
          >
            ▶️&nbsp;Start
          </button>
        </div>
        <div className="col" />
      </div>
    );
  }


  private start(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    this.props.start();
  }
}



// WEBPACK FOOTER //
// ./src/Doomsday/DoomsdayStart.tsx